var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeClick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 15.333,
    fill: "#E7C0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.395 8.656a.843.843 0 0 0-.847.84v4.654a.843.843 0 0 0 1.17.782.843.843 0 0 0 .52-.782V9.497a.844.844 0 0 0-.843-.84zm-9.966 3.457a.844.844 0 0 0-.599 1.439l3.29 3.296a.841.841 0 0 0 1.197 0 .844.844 0 0 0 0-1.197l-3.297-3.29a.844.844 0 0 0-.591-.248zm6.414 6.385a.844.844 0 0 0-.845 1.071l4.74 17.157a.844.844 0 0 0 1.54.206l2.79-4.747 3.862 3.861a.844.844 0 0 0 1.19 0l3.395-3.395a.844.844 0 0 0 0-1.19l-3.9-3.9 4.772-2.745a.844.844 0 0 0-.193-1.547l-17.156-4.74a.843.843 0 0 0-.195-.031zm-9.877 3.581a.845.845 0 0 0 0 1.69h4.653a.844.844 0 1 0 0-1.69H8.966z",
    fill: "#9334ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeClick);
export default __webpack_public_path__ + "static/media/homeClick.7c07a96c6b08a4a435369a5e1b21ae69.svg";
export { ForwardRef as ReactComponent };